export interface Cotisation {
    id: number;
    numPrime: string;
    type: string;
    etat: string;
    dateDebut: string;
    dateFin: string;
    datePay: string;
    montant: number;
    idContrat: string;
    idSouscripteur: string;
    createdAt: null;
    modifiedAt: null;
    dateEcheance: null;
    contrat: {
        cod: string;
        createdAt: string;
        dtDebutValidite: string;
        dtFinValidite: string;
        id: number;
        idCodCollege: string;
        idProduit: string;
        lbCollege: string;
        lbContrat: string;
        lbProduit: string;
        lbSouscripteur: string;
        modifiedAt: string;
        nbBeneficiaire: number;
        souscripteurCod: string;
        type: string;
    };
    souscripteur: {
        cod: string;
        libelle: string;
        client: string;
        adresse: string;
        codPos: string;
        burDis: string;
        siret: string;
        telephone: string;
        cc1: string;
    };
}

export const initCotisation = {
    id: 0,
    numPrime: '',
    type: '',
    etat: '',
    dateDebut: '',
    dateFin: '',
    datePay: '',
    montant: 0,
    idContrat: '',
    idSouscripteur: '',
    createdAt: null,
    modifiedAt: null,
    dateEcheance: null,
    contrat: {
        cod: '',
        createdAt: '',
        dtDebutValidite: '',
        dtFinValidite: '',
        id: 0,
        idCodCollege: '',
        idProduit: '',
        lbCollege: '',
        lbContrat: '',
        lbProduit: '',
        lbSouscripteur: '',
        modifiedAt: '',
        nbBeneficiaire: 0,
        souscripteurCod: '',
        type: '',
    },
    souscripteur: {
        cod: '',
        libelle: '',
        client: '',
        adresse: '',
        codPos: '',
        burDis: '',
        siret: '',
        telephone: '',
        cc1: '',
    },
};
